import Table from "table/Table";
import { LoadableQuery, SkeletalQuery } from "./SkeletalQuery";
import Query from "./Query";

export default class Schema {
    public name? : string;
    private _tables: Array<Table>
    // querys is initially populated with SkeletalQuerys which get lazily loaded to Querys when needed.
    private _querys: Array<LoadableQuery>; 
    public url : string = "";
    public namespace : string = "";

    constructor(url: string, namespace: string) {
        this.url = url;
        this.namespace = namespace;
        this._tables = [];
        this._querys = []; 
    }

    get tables() {
        return this._tables;
    }

    get querys() {
        return this._querys;
    }

    public add = (table: Table) => {
        this._tables.push(table);
    }

    public findTable: (tableName: string) => Table
        = (tableName) => {
            for (let each of this._tables) {
                if (tableName === each.name) {
                    return each;
                }
            }
            throw new Error(`Table not found: ${tableName}`);
        }

    public findTableMaybe: (tableName: string) => Table|null
        = (tableName) => {
            for (let each of this._tables) {
                if (tableName === each.name) {
                    return each;
                }
            }
            return null;
        }


    public generateStartingQueries = () => {
        this._tables.forEach(each => {
            let q = each.query().allColumns();
            this._querys.push(q);
        });
    }

    public replaceSkeletonWith = (me : SkeletalQuery, replaceWith: Query) => {
        let index = this._querys.findIndex(each => {
            return each === me
        });
        if (index < 0 || index >= this._querys.length) {
            throw new Error("Could not find skeleton to replace.");
        }
        this._querys[index] = replaceWith;
    }
}